/* Rotating title words for the Home page hero scroll */
export const words = [
  "Computational Physicist",
  "Psychic & Energy Healer",
  "Robotics Engineer",
  "Entrepreneur",
  "Parapsychological Researcher",
  "Content Creator",
];
